'use client';

import { useCallback } from 'react';
import Button from '@mui/material/Button';
import { useAppContext } from '@/contexts/app';

export default function SignUpButton() {
  const { login } = useAppContext();

  const handleLogin = useCallback(() => {
    login();
  }, [login]);

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleLogin}
      sx={{ whiteSpace: 'nowrap' }}
    >
      Sign Up
    </Button>
  );
}
